export const routesNames = {
  recharges: {
    base: '/recargas',
    details: '/recargas/detalhes',
    new_import_order: '/recargas/novo_pedido_importacao',
    new_import_order_values: '/recargas/novo_pedido_importacao_valores',
    import_order_confirmation: '/recargas/novo_pedido_importacao/confirmacao',
    import_order_payment: '/recargas/novo_pedido_importacao/pagamento',
    new_manual_order: '/recargas/novo_pedido_manual',
    new_manual_order_values: '/recargas/novo_pedido_manual_valores',
    manual_order_confirmation: '/recargas/novo_pedido_manual/confirmacao',
    brocker_manual_order_confirmation: '/recargas/novo_pedido_manual_broker/confirmacao',
    manual_order_payment: '/recargas/novo_pedido_manual/pagamento',
    broker_order_import: '/recargas/pedido_recarga_broker',
    broker_order_import_confirm: '/recargas/pedido_recarga_broker/dados',
    cart: '/carrinho',
    pix: '/recarga/pix',
  },
}
